export const LOCALE = 'de-AT';
export const LOCALE_DATE: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' };
export const LOCALE_DATE_TIME: Intl.DateTimeFormatOptions = { weekday: 'short', minute: 'numeric', hour: 'numeric', day: 'numeric', month: 'numeric', year: 'numeric' };
export const JSON_DATA_FILE_PREFIX = 'diagonale_';
export const CURRENT_YEAR = new Date().getFullYear();
export const FIRST_YEAR = 2019;
